import * as React from 'react';
import {AssetComponent} from "./AssetComponent";
import AssetResultContainerPagination from "./AssetResultContainerPagination";
import {AssetSearchRequest, AssetSearchResponse} from "../../api";
import { CartItem, SetCart } from '../utils/CartHelper';

export interface IAssetResultContainer {
    result?: AssetSearchResponse | null;
    request: AssetSearchRequest;
    cart: CartItem[];
    setCart: SetCart;
}

export const AssetResultContainer: React.FC<IAssetResultContainer> = ({result, request, cart, setCart}) => {

    const renderAssets = () => {
        if (!result) {
            return "";
        }

        return (result.result.map((asset) => {
            return <AssetComponent asset={asset} key={asset.id} cart={cart} setCart={setCart}/>;
        }));
    };

    const renderPagination = () => {
        if (!result) {
            return "";
        }

        return (
            <AssetResultContainerPagination result={result}
                                            request={request}/>);
    };

    return (<div>
        <section className="w-100 row">
            {renderAssets()}
        </section>

        {renderPagination()}
    </div>);
};

export default AssetResultContainer;
